import { useQuery } from "@tanstack/react-query";
import { getMaintainer } from "../services/maintainerServices";
import { getCookie } from "../utils";

export const useUserData = () => {
  const role = getCookie("role");
  const userId = getCookie("userId");

  const {
    data: maintainerData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["maintainerData", userId],
    queryFn: async () => {
      if (role === "maintainer") {
        const response = await getMaintainer(userId);
        return response.data;
      }
      return null;
    },
    enabled: role === "maintainer" && !!userId,
    retry: 1,
  });

  return {
    userRole: role,
    maintainerData,
    isLoading,
    isError,
    error,
  };
};
